export default "__VITE_ASSET__7d91c579__"